var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15455_78138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 50.0002L88.6794 37.4315L90.4519 20.6051L73.8983 17.1008L65.4544 2.43213L50 9.33919L47.9141 50.0002L50 90.6609L65.4546 97.568L73.8983 82.8995L90.4519 79.395L88.6794 62.5686L99.9999 50.0002Z",
    fill: "#A9CF4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5453 2.43213L26.1016 17.1008L9.54798 20.6053L11.3205 37.4315L0 50.0002L11.3205 62.5686L9.54798 79.395L26.1016 82.8995L34.5455 97.568L50.0001 90.6609V9.33919L34.5453 2.43213Z",
    fill: "#A9CF4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9611 39.052L66.5845 35.1455L50 53.726L47.9141 58.3436L50 62.536L70.9611 39.052Z",
    fill: "#F7F0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5709 45.582L28.4229 49.7303L45.8631 67.1707L50 62.5359V53.726L45.621 58.6319L32.5709 45.582Z",
    fill: "#F7F0EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15455_78138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImage);
export default __webpack_public_path__ + "static/media/check-image.5ef54ae2614b37559a13eb79a17c412a.svg";
export { ForwardRef as ReactComponent };